import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

/**
 * Visible breadcrumb trail. Pair with a BreadcrumbList JSON-LD in useSEO for SEO benefits.
 * The first item is always rendered as "Inicio" with a home icon if not provided.
 */
export const Breadcrumbs = ({ items, className }: BreadcrumbsProps) => {
  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex flex-wrap items-center gap-1 text-sm text-muted-foreground">
        <li className="flex items-center gap-1">
          <Link
            to="/"
            className="flex items-center gap-1 transition-colors hover:text-foreground"
            aria-label="Inicio"
          >
            <Home className="h-3.5 w-3.5" />
            <span className="sr-only md:not-sr-only">Inicio</span>
          </Link>
        </li>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1">
              <ChevronRight className="h-3.5 w-3.5 shrink-0 text-muted-foreground/60" />
              {isLast || !item.href ? (
                <span
                  className="max-w-[200px] truncate font-medium text-foreground sm:max-w-xs"
                  aria-current={isLast ? "page" : undefined}
                  title={item.label}
                >
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className="max-w-[160px] truncate transition-colors hover:text-foreground sm:max-w-xs"
                  title={item.label}
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
